// Gerçek desteklenen platform listesi — backend/capability_matrix.py ile senkron tutulmalı
// (79 platform, 2026-08-23 itibarıyla). Home.js ve ConnectedStores.js bu TEK listeyi paylaşır.
const supportedPlatforms = [
  'AliExpress', 'Alibaba.com', 'Allegro', 'Amazon', 'BASE', 'Bagisto', 'BigCartel', 'BigCommerce',
  'Bol.com', 'Bukalapak', 'CS-Cart', 'Cafe24', 'Cdiscount', 'Coupang', 'Drupal Commerce', 'EasyStore',
  'Ecwid', 'Elastic Path', 'Etsy', 'Facebook Marketplace', 'Fnac', 'GoDaddy Commerce',
  'Google Shopping', 'Gumroad', 'Haravan', 'JD Worldwide', 'Kajabi', 'Kaufland.de', 'Kibo Commerce',
  'Lazada', 'Lightspeed', 'Magento', 'Medusa.js', 'Newegg', 'OnBuy', 'OpenCart', 'Otto', 'Overstock',
  'PrestaShop', 'Qoo10', 'Rakuten', 'SAP Commerce Cloud', 'Saleor', 'Salesforce Commerce Cloud',
  'SamCart', 'Sapo', 'Shift4Shop', 'Shopee', 'Shopify', 'Shoplazza', 'Shopline', 'Shopware', 'Snapdeal',
  'Spree Commerce', 'Square Online', 'Squarespace', 'Sylius', 'Thinkific', 'Tiendanube', 'TikTok Shop',
  'Tmall Global', 'Tokopedia', 'VTEX', 'Volusion', 'Walmart Marketplace', 'Wayfair',
  'Webflow Ecommerce', 'Wish', 'Wix', 'WooCommerce', 'X-Cart', 'Yampi', 'Zalando', 'commercetools',
  'eBay', 'nopCommerce', 'osCommerce', 'real.de',
];

export default supportedPlatforms;
